// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconNotificationWarning: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 16 15">
            <path
                fill="#AC8613"
                d="M8,0 C8.46850979,0 8.87455161,0.25 9.09318951,0.65625 L15.8397305,13.15625 C16.0583684,13.53125 16.0583684,14 15.8084965,14.40625 C15.5898586,14.78125 15.1838168,15 14.746541,15 L1.25345904,15 C0.816183239,15 0.410141422,14.78125 0.191503521,14.40625 C-0.0583683663,14 -0.0583683663,13.53125 0.160269535,13.15625 L6.90681049,0.65625 C7.12544839,0.25 7.53149021,0 8,0 Z M8,5.25 C7.59395818,5.25 7.25038434,5.59375 7.25038434,6 L7.25038434,9.5 C7.25038434,9.90625 7.59395818,10.25 8,10.25 C8.40604182,10.25 8.74961566,9.90625 8.74961566,9.5 L8.74961566,6 C8.74961566,5.59375 8.40604182,5.25 8,5.25 Z M8.84331762,12 C8.84331762,11.6875 8.68714769,11.40625 8.4372758,11.25 C8.15616993,11.0625 7.84383007,11.0625 7.5627242,11.25 C7.31285231,11.40625 7.15668238,11.6875 7.15668238,12 C7.15668238,12.3125 7.31285231,12.59375 7.5627242,12.75 C7.84383007,12.9375 8.15616993,12.9375 8.4372758,12.75 C8.68714769,12.59375 8.84331762,12.3125 8.84331762,12 Z"
            />
        </svg>
    );
};

export default React.memo(IconNotificationWarning);
